import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, vShow as _vShow, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5f83a719")

_pushScopeId("data-v-5f83a719")
const _hoisted_1 = {
  key: 2,
  class: "fixed top-4 left-1/2 transform -translate-x-1/2 z-50 px-6 py-3 bg-green-500 text-white rounded-md shadow-lg transition-opacity duration-300"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("スクール情報を編集")
const _hoisted_3 = {
  key: 0,
  class: "w-3/4 p-3 mx-auto mb-6 flex items-center bg-red-100 rounded-md"
}
const _hoisted_4 = { class: "text-red-500" }
const _hoisted_5 = /*#__PURE__*/_createVNode("p", { class: "ml-2 font-medium text-sm text-gray-700" }, " 現在休会中です。休会から復帰させたい場合は入力ウィンドウ右下の「休会解除」ボタンを押してください ", -1)
const _hoisted_6 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_7 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_8 = /*#__PURE__*/_createVNode("label", {
  for: "name",
  class: "leading-7 text-sm text-gray-600"
}, " スクール名称 ", -1)
const _hoisted_9 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_10 = {
  key: 1,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_11 = {
  key: 2,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_12 = {
  key: 3,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, "契約区分", -1)
const _hoisted_14 = { class: "p-4 bg-primary-100 rounded-md mb-4" }
const _hoisted_15 = { class: "flex items-center" }
const _hoisted_16 = /*#__PURE__*/_createVNode("label", {
  for: "paid-subscription",
  class: "pl-2 cursor-pointer font-medium"
}, "有料", -1)
const _hoisted_17 = {
  key: 0,
  class: "mt-3 ml-6 p-3 bg-white rounded-md"
}
const _hoisted_18 = { class: "mb-3" }
const _hoisted_19 = { class: "p-4 bg-primary-100 rounded-md mb-4" }
const _hoisted_20 = { class: "flex items-center" }
const _hoisted_21 = /*#__PURE__*/_createVNode("label", {
  for: "free-subscription",
  class: "pl-2 cursor-pointer font-medium"
}, "無料", -1)
const _hoisted_22 = {
  key: 0,
  class: "mt-3 ml-6 p-3 bg-white rounded-md"
}
const _hoisted_23 = { class: "mb-3" }
const _hoisted_24 = { class: "p-4 bg-primary-100 rounded-md" }
const _hoisted_25 = { class: "flex items-center" }
const _hoisted_26 = /*#__PURE__*/_createVNode("label", {
  for: "other-subscription",
  class: "pl-2 cursor-pointer font-medium"
}, "その他", -1)
const _hoisted_27 = {
  key: 4,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_28 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, "都道府県", -1)
const _hoisted_29 = { class: "p-4 bg-primary-100 rounded-md" }
const _hoisted_30 = { class: "flex flex-wrap gap-2" }
const _hoisted_31 = {
  key: 5,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_32 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, "学校区分", -1)
const _hoisted_33 = { class: "p-4 bg-primary-100 rounded-md" }
const _hoisted_34 = {
  key: 6,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_35 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, "設立主体区分", -1)
const _hoisted_36 = { class: "p-4 bg-primary-100 rounded-md" }
const _hoisted_37 = {
  key: 7,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_38 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, "ユーザー契約範囲", -1)
const _hoisted_39 = { class: "p-4 bg-primary-100 rounded-md" }
const _hoisted_40 = {
  key: 8,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_41 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, "役割", -1)
const _hoisted_42 = { class: "p-4 flex items-center bg-primary-100 rounded-md" }
const _hoisted_43 = /*#__PURE__*/_createVNode("label", {
  for: "add-role",
  class: "pl-2 cursor-pointer"
}, " 役割を追加する ", -1)
const _hoisted_44 = { class: "ml-6" }
const _hoisted_45 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_46 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, [
  /*#__PURE__*/_createVNode("span", { class: "font-medium" }, "生徒用帳票を表示しない")
], -1)
const _hoisted_47 = { class: "p-4 flex items-center bg-primary-100 rounded-md" }
const _hoisted_48 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_49 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, [
  /*#__PURE__*/_createVNode("span", { class: "font-medium" }, "生徒のログインパスワード変更を可能にする")
], -1)
const _hoisted_50 = { class: "p-4 flex items-center bg-primary-100 rounded-md" }
const _hoisted_51 = {
  key: 9,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_52 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, [
  /*#__PURE__*/_createVNode("span", { class: "font-medium" }, "みんがく学習室を表示しない")
], -1)
const _hoisted_53 = { class: "p-4 flex items-center bg-primary-100 rounded-md" }
const _hoisted_54 = {
  key: 10,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_55 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, [
  /*#__PURE__*/_createVNode("span", { class: "font-medium" }, "学習室のみ利用")
], -1)
const _hoisted_56 = { class: "p-4 flex items-center bg-primary-100 rounded-md" }
const _hoisted_57 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_58 = {
  key: 0,
  class: "leading-7 text-sm text-gray-600"
}
const _hoisted_59 = /*#__PURE__*/_createVNode("span", { class: "font-medium" }, "スクールAIの機能のみを利用する", -1)
const _hoisted_60 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_61 = {
  key: 1,
  class: "leading-7 text-sm text-gray-600"
}
const _hoisted_62 = { class: "p-4 flex items-center bg-primary-100 rounded-md" }
const _hoisted_63 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_64 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, " スクールAI上でプロンプトの作成を禁止する ", -1)
const _hoisted_65 = { class: "p-4 flex items-center bg-primary-100 rounded-md" }
const _hoisted_66 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_67 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, " 生徒プロンプト作成を禁止する ", -1)
const _hoisted_68 = { class: "p-4 flex items-center bg-primary-100 rounded-md" }
const _hoisted_69 = {
  key: 11,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_70 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, " 学習カードの利用を許可する ", -1)
const _hoisted_71 = { class: "p-4 flex items-center bg-primary-100 rounded-md" }
const _hoisted_72 = {
  key: 12,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_73 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, " スクール管理者にスタッフのチャット閲覧を可能にする ", -1)
const _hoisted_74 = { class: "p-4 flex items-center bg-primary-100 rounded-md" }
const _hoisted_75 = {
  key: 13,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_76 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, " デジタルドリルの利用を許可する ", -1)
const _hoisted_77 = { class: "p-4 flex items-center bg-primary-100 rounded-md" }
const _hoisted_78 = {
  key: 14,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_79 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, " プリント提出機能の利用を許可する ", -1)
const _hoisted_80 = { class: "p-4 flex items-center bg-primary-100 rounded-md" }
const _hoisted_81 = {
  key: 15,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_82 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, " スクールAIのチャットを音声入力で送信した場合に音声ファイルを保存する機能を付与する ", -1)
const _hoisted_83 = { class: "p-4 flex items-center bg-primary-100 rounded-md" }
const _hoisted_84 = {
  key: 16,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_85 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, " スクールAIの先生用メニューに教材作成（カワセミライト）を表示する ", -1)
const _hoisted_86 = { class: "p-4 flex items-center bg-primary-100 rounded-md" }
const _hoisted_87 = {
  key: 17,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_88 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, [
  /*#__PURE__*/_createVNode("span", { class: "font-medium" }, "スクールAIのアプリ管理画面でテンプレートとガイドを表示する"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" ※子スクールの場合、デフォルトでは表示されません。このチェックを入れると表示されます。 ")
], -1)
const _hoisted_89 = { class: "p-4 flex items-center bg-primary-100 rounded-md" }
const _hoisted_90 = {
  key: 18,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_91 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, " アプリの公開申請および公開を許可する ", -1)
const _hoisted_92 = { class: "p-4 flex items-center bg-primary-100 rounded-md" }
const _hoisted_93 = {
  key: 19,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_94 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, " 会話圧縮カナリアリリース対象にする ", -1)
const _hoisted_95 = { class: "p-4 flex items-center bg-primary-100 rounded-md" }
const _hoisted_96 = {
  key: 20,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_97 = {
  key: 21,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_98 = {
  key: 22,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_99 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, "スクールAI 利用回数制限", -1)
const _hoisted_100 = { class: "rounded-md bg-primary-100 divide-y divide-primary-200" }
const _hoisted_101 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("p", { class: "text-sm font-medium text-gray-700" }, " 生徒アカウント向け "),
  /*#__PURE__*/_createVNode("p", { class: "mt-0.5 text-xs text-gray-500" }, "ユーザー単位の制限")
], -1)
const _hoisted_102 = { class: "flex items-center gap-2" }
const _hoisted_103 = {
  key: 0,
  class: "px-2 py-0.5 text-xs font-medium rounded-full bg-green-100 text-green-700"
}
const _hoisted_104 = {
  key: 1,
  class: "px-2 py-0.5 text-xs font-medium rounded-full bg-gray-100 text-gray-500"
}
const _hoisted_105 = /*#__PURE__*/_createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M19 9l-7 7-7-7"
}, null, -1)
const _hoisted_106 = { class: "space-y-3 p-4 border-t border-primary-200" }
const _hoisted_107 = { class: "rounded-md border border-gray-200 bg-white px-4 py-4" }
const _hoisted_108 = { class: "flex items-center" }
const _hoisted_109 = /*#__PURE__*/_createVNode("span", { class: "pl-2 cursor-pointer" }, "有効にする", -1)
const _hoisted_110 = { class: "rounded-md border border-gray-200 bg-white px-4 py-4" }
const _hoisted_111 = { class: "rounded-md border border-gray-200 bg-white px-4 py-4" }
const _hoisted_112 = { class: "rounded-md border border-gray-200 bg-white px-4 py-4" }
const _hoisted_113 = { class: "flex items-center" }
const _hoisted_114 = /*#__PURE__*/_createVNode("span", { class: "pl-2 cursor-pointer" }, " スクールの先生に生徒個別制限の設定を許可する ", -1)
const _hoisted_115 = /*#__PURE__*/_createVNode("p", { class: "mt-2 text-xs text-gray-500" }, " OFF の場合、生徒の「個人データを編集」モーダルには個別設定を表示せず、 常にスクールレベル制限を適用します。 ", -1)
const _hoisted_116 = { class: "rounded-md border border-gray-200 bg-white px-4 py-4" }
const _hoisted_117 = /*#__PURE__*/_createVNode("p", { class: "mt-2 text-xs text-gray-500" }, " 未設定の場合は送信回数上限の20%以下で警告表示します。 ", -1)
const _hoisted_118 = { class: "rounded-md border border-gray-200 bg-white px-4 py-4" }
const _hoisted_119 = { class: "flex items-center" }
const _hoisted_120 = /*#__PURE__*/_createVNode("span", { class: "pl-2 cursor-pointer" }, " システムプロンプトもカウント対象にする ", -1)
const _hoisted_121 = { class: "rounded-md border border-gray-200 bg-white px-4 py-4" }
const _hoisted_122 = /*#__PURE__*/_createVNode("p", { class: "mt-2 text-xs text-gray-500" }, " 未設定の場合の有効期限は無期限です。 ", -1)
const _hoisted_123 = /*#__PURE__*/_createVNode("p", { class: "mt-1 text-xs text-gray-500" }, " 有効期限内に送信されたチャットのみ、この制限の送信回数としてカウントされます。 ", -1)
const _hoisted_124 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("p", { class: "text-sm font-medium text-gray-700" }, " 先生アカウント向け "),
  /*#__PURE__*/_createVNode("p", { class: "mt-0.5 text-xs text-gray-500" }, "ユーザー単位の制限")
], -1)
const _hoisted_125 = { class: "flex items-center gap-2" }
const _hoisted_126 = {
  key: 0,
  class: "px-2 py-0.5 text-xs font-medium rounded-full bg-green-100 text-green-700"
}
const _hoisted_127 = {
  key: 1,
  class: "px-2 py-0.5 text-xs font-medium rounded-full bg-gray-100 text-gray-500"
}
const _hoisted_128 = /*#__PURE__*/_createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M19 9l-7 7-7-7"
}, null, -1)
const _hoisted_129 = { class: "space-y-3 p-4 border-t border-primary-200" }
const _hoisted_130 = { class: "rounded-md border border-gray-200 bg-white px-4 py-4" }
const _hoisted_131 = { class: "flex items-center" }
const _hoisted_132 = /*#__PURE__*/_createVNode("span", { class: "pl-2 cursor-pointer" }, "有効にする", -1)
const _hoisted_133 = { class: "rounded-md border border-gray-200 bg-white px-4 py-4" }
const _hoisted_134 = { class: "rounded-md border border-gray-200 bg-white px-4 py-4" }
const _hoisted_135 = { class: "rounded-md border border-gray-200 bg-white px-4 py-4" }
const _hoisted_136 = /*#__PURE__*/_createVNode("p", { class: "mt-2 text-xs text-gray-500" }, " 未設定の場合は送信回数上限の20%以下で警告表示します。 ", -1)
const _hoisted_137 = { class: "rounded-md border border-gray-200 bg-white px-4 py-4" }
const _hoisted_138 = { class: "flex items-center" }
const _hoisted_139 = /*#__PURE__*/_createVNode("span", { class: "pl-2 cursor-pointer" }, " システムプロンプトもカウント対象にする ", -1)
const _hoisted_140 = { class: "rounded-md border border-gray-200 bg-white px-4 py-4" }
const _hoisted_141 = /*#__PURE__*/_createVNode("p", { class: "mt-2 text-xs text-gray-500" }, " 未設定の場合の有効期限は無期限です。 ", -1)
const _hoisted_142 = /*#__PURE__*/_createVNode("p", { class: "mt-1 text-xs text-gray-500" }, " 有効期限内に送信されたチャットのみ、この制限の送信回数としてカウントされます。 ", -1)
const _hoisted_143 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("p", { class: "text-sm font-medium text-gray-700" }, " スクール全体向け "),
  /*#__PURE__*/_createVNode("p", { class: "mt-0.5 text-xs text-gray-500" }, " スクール単位の合計制限 ")
], -1)
const _hoisted_144 = { class: "flex items-center gap-2" }
const _hoisted_145 = {
  key: 0,
  class: "px-2 py-0.5 text-xs font-medium rounded-full bg-green-100 text-green-700"
}
const _hoisted_146 = {
  key: 1,
  class: "px-2 py-0.5 text-xs font-medium rounded-full bg-gray-100 text-gray-500"
}
const _hoisted_147 = /*#__PURE__*/_createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M19 9l-7 7-7-7"
}, null, -1)
const _hoisted_148 = { class: "space-y-3 p-4 border-t border-primary-200" }
const _hoisted_149 = { class: "rounded-md border border-gray-200 bg-white px-4 py-4" }
const _hoisted_150 = { class: "flex items-center" }
const _hoisted_151 = /*#__PURE__*/_createVNode("span", { class: "pl-2 cursor-pointer" }, "有効にする", -1)
const _hoisted_152 = { class: "rounded-md border border-gray-200 bg-white px-4 py-4" }
const _hoisted_153 = { class: "rounded-md border border-gray-200 bg-white px-4 py-4" }
const _hoisted_154 = { class: "rounded-md border border-gray-200 bg-white px-4 py-4" }
const _hoisted_155 = /*#__PURE__*/_createVNode("p", { class: "mt-2 text-xs text-gray-500" }, " 未設定の場合は送信回数上限の20%以下で警告表示します。 ", -1)
const _hoisted_156 = { class: "rounded-md border border-gray-200 bg-white px-4 py-4" }
const _hoisted_157 = { class: "flex items-center" }
const _hoisted_158 = /*#__PURE__*/_createVNode("span", { class: "pl-2 cursor-pointer" }, " システムプロンプトもカウント対象にする ", -1)
const _hoisted_159 = { class: "rounded-md border border-gray-200 bg-white px-4 py-4" }
const _hoisted_160 = /*#__PURE__*/_createVNode("p", { class: "mt-2 text-xs text-gray-500" }, " 未設定の場合の有効期限は無期限です。 ", -1)
const _hoisted_161 = /*#__PURE__*/_createVNode("p", { class: "mt-1 text-xs text-gray-500" }, " 有効期限内に送信されたチャットのみ、この制限の送信回数としてカウントされます。 ", -1)
const _hoisted_162 = {
  key: 23,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_163 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, " AI の利用額の上限（生徒 1 人あたり・月） ", -1)
const _hoisted_164 = { class: "p-4 rounded-md bg-primary-100" }
const _hoisted_165 = { class: "flex items-center justify-between gap-3" }
const _hoisted_166 = { class: "font-medium text-gray-900" }
const _hoisted_167 = { class: "text-xs text-gray-500" }
const _hoisted_168 = {
  key: 0,
  class: "text-xs text-gray-500"
}
const _hoisted_169 = /*#__PURE__*/_createTextVNode(" 変更する ")
const _hoisted_170 = {
  key: 0,
  class: "mt-3 flex flex-col text-xs text-gray-500"
}
const _hoisted_171 = { class: "flex flex-col text-sm" }
const _hoisted_172 = { class: "font-medium text-gray-900" }
const _hoisted_173 = { class: "text-xs text-gray-500" }
const _hoisted_174 = { class: "text-xs text-gray-500" }
const _hoisted_175 = { class: "text-xs text-gray-500" }
const _hoisted_176 = { class: "text-xs text-gray-500" }
const _hoisted_177 = /*#__PURE__*/_createTextVNode(" 予定を取り消す ")
const _hoisted_178 = {
  key: 24,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_179 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, "追加機能", -1)
const _hoisted_180 = { class: "p-4 flex items-center bg-primary-100 rounded-md" }
const _hoisted_181 = /*#__PURE__*/_createVNode("label", {
  for: "notification",
  class: "pl-2 cursor-pointer"
}, " スクール独自の学習室開室機能 ", -1)
const _hoisted_182 = { class: "ml-6" }
const _hoisted_183 = /*#__PURE__*/_createTextVNode(" zoomアカウント: ")
const _hoisted_184 = { class: "p-4 flex items-center bg-primary-100 rounded-md" }
const _hoisted_185 = /*#__PURE__*/_createVNode("label", {
  for: "lineOfficialAccount",
  class: "pl-2 cursor-pointer"
}, " 独自公式LINEを利用 ", -1)
const _hoisted_186 = { class: "ml-6 mb-2" }
const _hoisted_187 = /*#__PURE__*/_createTextVNode(" チャネルアクセストークン(Messaging API): ")
const _hoisted_188 = { class: "ml-6 mb-2" }
const _hoisted_189 = /*#__PURE__*/_createTextVNode(" チャネルシークレット(Messaging API): ")
const _hoisted_190 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_191 = {
  key: 25,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_192 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, "メールアドレス", -1)
const _hoisted_193 = { class: "px-4 py-2 flex flex-col items-start bg-primary-100 rounded-md" }
const _hoisted_194 = { class: "rounded" }
const _hoisted_195 = /*#__PURE__*/_createTextVNode(" 変更する ")
const _hoisted_196 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_197 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm text-gray-600" }, "ステータス", -1)
const _hoisted_198 = { class: "px-4 py-2 flex items-center bg-primary-100 rounded-md" }
const _hoisted_199 = { class: "border-gray-300 rounded" }
const _hoisted_200 = /*#__PURE__*/_createTextVNode(" 休会解除 ")
const _hoisted_201 = /*#__PURE__*/_createTextVNode(" 休会に変更 ")
const _hoisted_202 = /*#__PURE__*/_createTextVNode(" 変更を保存 ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MscChangeEmailModal = _resolveComponent("MscChangeEmailModal")
  const _component_MscLlmUsageLimitModal = _resolveComponent("MscLlmUsageLimitModal")
  const _component_m_icon = _resolveComponent("m-icon")
  const _component_m_text_field = _resolveComponent("m-text-field")
  const _component_m_select_box = _resolveComponent("m-select-box")
  const _component_m_button = _resolveComponent("m-button")
  const _component_MBaseModal = _resolveComponent("MBaseModal")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.showChangeEmailModal)
      ? (_openBlock(), _createBlock(_component_MscChangeEmailModal, {
          key: 0,
          "current-email": _ctx.selectedTutorEmail,
          onClose: _ctx.closeChangeEmailModal,
          onConfirm: _ctx.confirmChangeEmail
        }, null, 8, ["current-email", "onClose", "onConfirm"]))
      : _createCommentVNode("", true),
    (_ctx.showLlmUsageLimitModal)
      ? (_openBlock(), _createBlock(_component_MscLlmUsageLimitModal, {
          key: 1,
          "school-id": _ctx.schoolConfig.ref.id,
          "llm-usage-limits": _ctx.llmUsageLimits,
          "subscription-type": _ctx.schoolConfig.data.subscriptionType,
          limits: _ctx.limits,
          "current-text": _ctx.llmUsageLimitCurrentText,
          "current-source-text": _ctx.llmUsageLimitCurrentSourceText,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showLlmUsageLimitModal = false)),
          onUpdated: _ctx.onLlmUsageLimitsUpdated
        }, null, 8, ["school-id", "llm-usage-limits", "subscription-type", "limits", "current-text", "current-source-text", "onUpdated"]))
      : _createCommentVNode("", true),
    (_ctx.showToast)
      ? (_openBlock(), _createBlock("div", _hoisted_1, " 変更を保存しました "))
      : _createCommentVNode("", true),
    _createVNode(_component_MBaseModal, { onClose: _ctx.close }, {
      title: _withId(() => [
        _hoisted_2
      ]),
      body: _withId(() => [
        (_ctx.inRecess)
          ? (_openBlock(), _createBlock("div", _hoisted_3, [
              _createVNode("div", _hoisted_4, [
                _createVNode(_component_m_icon, {
                  type: "warning",
                  size: "6"
                })
              ]),
              _hoisted_5
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_m_text_field, {
            label: "スクールID (重複不可)",
            name: "id",
            type: "text",
            placeholder: "6桁の半角数字",
            value: _ctx.schoolId,
            invalid: !_ctx.validId,
            onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.schoolId = $event))
          }, null, 8, ["value", "invalid"])
        ]),
        _createVNode("div", _hoisted_7, [
          _hoisted_8,
          _withDirectives(_createVNode("input", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.schoolName = $event)),
            type: "text",
            name: "name",
            placeholder: "例）みんがくスクール",
            class: "w-full bg-primary-100 rounded border border-primary-100 focus:border-primary-500 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-300"
          }, null, 512), [
            [_vModelText, _ctx.schoolName]
          ])
        ]),
        _createVNode("div", _hoisted_9, [
          _createVNode(_component_m_select_box, {
            key: "ref.id",
            label: "スクール領域",
            name: "target",
            placeholder: "スクール領域を選択",
            options: _ctx.targets,
            value: _ctx.selectedTargetId,
            "value-key": "ref.id",
            "text-key": "data.name",
            onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectedTargetId = $event))
          }, null, 8, ["options", "value"])
        ]),
        (_ctx.isSuperAdmin)
          ? (_openBlock(), _createBlock("div", _hoisted_10, [
              _createVNode(_component_m_select_box, {
                key: "key",
                label: "支払方法",
                name: "payment",
                placeholder: "支払方法を選択",
                options: _ctx.paymentTypes,
                value: _ctx.paymentType,
                "value-key": "key",
                "text-key": "name",
                onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.paymentType = $event))
              }, null, 8, ["options", "value"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isSuperAdmin)
          ? (_openBlock(), _createBlock("div", _hoisted_11, [
              _createVNode(_component_m_text_field, {
                label: "スクールAI利用期限日",
                name: "schoolAiUsageExpiresAtDate",
                type: "date",
                placeholder: "未設定の場合は制限なし",
                value: _ctx.schoolAiUsageExpiresAtDate,
                onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.schoolAiUsageExpiresAtDate = $event))
              }, null, 8, ["value"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isSuperAdmin)
          ? (_openBlock(), _createBlock("div", _hoisted_12, [
              _hoisted_13,
              _createVNode("div", _hoisted_14, [
                _createVNode("div", _hoisted_15, [
                  _createVNode("input", {
                    id: "paid-subscription",
                    checked: _ctx.isPaidSubscription,
                    type: "checkbox",
                    name: "paid-subscription",
                    class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded",
                    onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onSubscriptionCheck('paid')))
                  }, null, 40, ["checked"]),
                  _hoisted_16
                ]),
                (_ctx.isPaidSubscription)
                  ? (_openBlock(), _createBlock("div", _hoisted_17, [
                      _createVNode("div", _hoisted_18, [
                        _createVNode(_component_m_text_field, {
                          label: "契約開始日",
                          name: "paidSubscriptionStartDay",
                          type: "date",
                          placeholder: "2024/04/01",
                          value: _ctx.paidSubscriptionStartDay,
                          onInput: _cache[8] || (_cache[8] = ($event: any) => (_ctx.paidSubscriptionStartDay = $event))
                        }, null, 8, ["value"])
                      ]),
                      _createVNode(_component_m_text_field, {
                        label: "契約終了日",
                        name: "paidSubscriptionEndDay",
                        type: "date",
                        placeholder: "2025/03/31",
                        value: _ctx.paidSubscriptionEndDay,
                        onInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.paidSubscriptionEndDay = $event))
                      }, null, 8, ["value"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_19, [
                _createVNode("div", _hoisted_20, [
                  _createVNode("input", {
                    id: "free-subscription",
                    checked: _ctx.isFreeSubscription,
                    type: "checkbox",
                    name: "free-subscription",
                    class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded",
                    onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onSubscriptionCheck('free')))
                  }, null, 40, ["checked"]),
                  _hoisted_21
                ]),
                (_ctx.isFreeSubscription)
                  ? (_openBlock(), _createBlock("div", _hoisted_22, [
                      _createVNode("div", _hoisted_23, [
                        _createVNode(_component_m_text_field, {
                          label: "契約開始日",
                          name: "freeSubscriptionStartDay",
                          type: "date",
                          placeholder: "2024/04/01",
                          value: _ctx.freeSubscriptionStartDay,
                          onInput: _cache[11] || (_cache[11] = ($event: any) => (_ctx.freeSubscriptionStartDay = $event))
                        }, null, 8, ["value"])
                      ]),
                      _createVNode(_component_m_text_field, {
                        label: "契約終了日",
                        name: "freeSubscriptionEndDay",
                        type: "date",
                        placeholder: "2025/03/31",
                        value: _ctx.freeSubscriptionEndDay,
                        onInput: _cache[12] || (_cache[12] = ($event: any) => (_ctx.freeSubscriptionEndDay = $event))
                      }, null, 8, ["value"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_24, [
                _createVNode("div", _hoisted_25, [
                  _createVNode("input", {
                    id: "other-subscription",
                    checked: _ctx.isOtherSubscription,
                    type: "checkbox",
                    name: "other-subscription",
                    class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded",
                    onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.onSubscriptionCheck('other')))
                  }, null, 40, ["checked"]),
                  _hoisted_26
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isSuperAdmin)
          ? (_openBlock(), _createBlock("div", _hoisted_27, [
              _hoisted_28,
              _createVNode("div", _hoisted_29, [
                _createVNode("div", _hoisted_30, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.PREFECTURES, (p) => {
                    return (_openBlock(), _createBlock("button", {
                      key: p,
                      type: "button",
                      class: [
                'border rounded px-2 py-1 text-sm transition-colors',
                _ctx.prefecture === p
                  ? 'bg-primary-500 text-white border-primary-500'
                  : 'bg-white border-gray-300 hover:border-primary-500'
              ],
                      onClick: ($event: any) => (_ctx.prefecture = _ctx.prefecture === p ? null : p)
                    }, _toDisplayString(p), 11, ["onClick"]))
                  }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isSuperAdmin)
          ? (_openBlock(), _createBlock("div", _hoisted_31, [
              _hoisted_32,
              _createVNode("div", _hoisted_33, [
                _createVNode(_component_m_select_box, {
                  name: "schoolCategory",
                  options: _ctx.schoolCategoryOptions,
                  value: _ctx.schoolCategory ?? '',
                  "value-key": "key",
                  "text-key": "name",
                  onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.schoolCategory = $event || null))
                }, null, 8, ["options", "value"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isSuperAdmin)
          ? (_openBlock(), _createBlock("div", _hoisted_34, [
              _hoisted_35,
              _createVNode("div", _hoisted_36, [
                _createVNode(_component_m_select_box, {
                  name: "foundingBody",
                  options: _ctx.foundingBodyOptions,
                  value: _ctx.foundingBody ?? '',
                  "value-key": "key",
                  "text-key": "name",
                  onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.foundingBody = $event || null))
                }, null, 8, ["options", "value"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isSuperAdmin)
          ? (_openBlock(), _createBlock("div", _hoisted_37, [
              _hoisted_38,
              _createVNode("div", _hoisted_39, [
                _createVNode(_component_m_select_box, {
                  name: "userContractScope",
                  options: _ctx.userContractScopeOptions,
                  value: _ctx.userContractScope ?? '',
                  "value-key": "key",
                  "text-key": "name",
                  onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.userContractScope = $event || null))
                }, null, 8, ["options", "value"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isSuperAdmin)
          ? (_openBlock(), _createBlock("div", _hoisted_40, [
              _hoisted_41,
              _createVNode("div", _hoisted_42, [
                _withDirectives(_createVNode("input", {
                  id: "add-role",
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.addRole = $event)),
                  type: "checkbox",
                  name: "add-role",
                  class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.addRole]
                ]),
                _hoisted_43,
                _withDirectives(_createVNode("div", _hoisted_44, [
                  _createVNode(_component_m_select_box, {
                    key: "key",
                    name: "role",
                    placeholder: "役割を選択",
                    options: [
                {
                  key: 'serviceProvider',
                  name: `${
                    _ctx.isSelectedTargetSchool ? '教育委員会' : 'サービス管理人'
                  }`
                }
              ],
                    value: _ctx.role[0],
                    "value-key": "key",
                    "text-key": "name",
                    onChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.role[0] = $event))
                  }, null, 8, ["options", "value"])
                ], 512), [
                  [_vShow, _ctx.addRole]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_45, [
          _hoisted_46,
          _createVNode("div", _hoisted_47, [
            _withDirectives(_createVNode("input", {
              id: "display-login-invitation",
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.hideLoginInvitaion = $event)),
              type: "checkbox",
              name: "display-login-invitation",
              class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
            }, null, 512), [
              [_vModelCheckbox, _ctx.hideLoginInvitaion]
            ])
          ])
        ]),
        _createVNode("div", _hoisted_48, [
          _hoisted_49,
          _createVNode("div", _hoisted_50, [
            _withDirectives(_createVNode("input", {
              id: "display-login-invitation",
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.allowStudentsToChangePassword = $event)),
              type: "checkbox",
              name: "display-login-invitation",
              class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
            }, null, 512), [
              [_vModelCheckbox, _ctx.allowStudentsToChangePassword]
            ])
          ])
        ]),
        (_ctx.isSuperAdmin)
          ? (_openBlock(), _createBlock("div", _hoisted_51, [
              _hoisted_52,
              _createVNode("div", _hoisted_53, [
                _withDirectives(_createVNode("input", {
                  id: "display-login-invitation",
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.hideMingakuStudyRoom = $event)),
                  type: "checkbox",
                  name: "display-login-invitation",
                  class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.hideMingakuStudyRoom]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isSuperAdmin)
          ? (_openBlock(), _createBlock("div", _hoisted_54, [
              _hoisted_55,
              _createVNode("div", _hoisted_56, [
                _withDirectives(_createVNode("input", {
                  id: "use-study-room-only",
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.useStudyRoomOnly = $event)),
                  type: "checkbox",
                  name: "use-study-room-only",
                  class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.useStudyRoomOnly]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_57, [
          (_ctx.isServiceProvider)
            ? (_openBlock(), _createBlock("p", _hoisted_58, [
                _hoisted_59,
                _hoisted_60,
                _createTextVNode(" " + _toDisplayString(`※${
              _ctx.isSchool ? "教育委員会" : "サービス管理人"
            }は編集することができません。変更の希望がある場合はみんがくまでお問い合わせください。`), 1)
              ]))
            : (_openBlock(), _createBlock("p", _hoisted_61, " スクールAIの機能のみを利用する ")),
          _createVNode("div", _hoisted_62, [
            _withDirectives(_createVNode("input", {
              id: "use-school-ai-exclusively",
              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.useSchoolAiExclusively = $event)),
              type: "checkbox",
              name: "add-role",
              class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded",
              disabled: _ctx.isServiceProvider ? true : false
            }, null, 8, ["disabled"]), [
              [_vModelCheckbox, _ctx.useSchoolAiExclusively]
            ])
          ])
        ]),
        _createVNode("div", _hoisted_63, [
          _hoisted_64,
          _createVNode("div", _hoisted_65, [
            _withDirectives(_createVNode("input", {
              id: "is-prompt-creation-forbidden",
              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.isPromptCreationForbidden = $event)),
              type: "checkbox",
              name: "is-prompt-creation-forbidden",
              class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
            }, null, 512), [
              [_vModelCheckbox, _ctx.isPromptCreationForbidden]
            ])
          ])
        ]),
        _createVNode("div", _hoisted_66, [
          _hoisted_67,
          _createVNode("div", _hoisted_68, [
            _withDirectives(_createVNode("input", {
              id: "allow-students-to-create-prompts",
              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.disableStudentsPromptCreation = $event)),
              type: "checkbox",
              name: "allow-students-to-create-prompts",
              class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
            }, null, 512), [
              [_vModelCheckbox, _ctx.disableStudentsPromptCreation]
            ])
          ])
        ]),
        (_ctx.isSuperAdmin)
          ? (_openBlock(), _createBlock("div", _hoisted_69, [
              _hoisted_70,
              _createVNode("div", _hoisted_71, [
                _withDirectives(_createVNode("input", {
                  id: "can-use-learning-card",
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.canUseLearningCard = $event)),
                  type: "checkbox",
                  name: "can-use-learning-card",
                  class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.canUseLearningCard]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isSuperAdmin)
          ? (_openBlock(), _createBlock("div", _hoisted_72, [
              _hoisted_73,
              _createVNode("div", _hoisted_74, [
                _withDirectives(_createVNode("input", {
                  id: "allow-owners-to-view-chats",
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.canOwnerViewOtherStaffChats = $event)),
                  type: "checkbox",
                  name: "allow-owners-to-view-chats",
                  class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.canOwnerViewOtherStaffChats]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isSuperAdmin)
          ? (_openBlock(), _createBlock("div", _hoisted_75, [
              _hoisted_76,
              _createVNode("div", _hoisted_77, [
                _withDirectives(_createVNode("input", {
                  id: "can-use-digital-drill",
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.canUseDigitalDrill = $event)),
                  type: "checkbox",
                  name: "can-use-digital-drill",
                  class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.canUseDigitalDrill]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isSuperAdmin)
          ? (_openBlock(), _createBlock("div", _hoisted_78, [
              _hoisted_79,
              _createVNode("div", _hoisted_80, [
                _withDirectives(_createVNode("input", {
                  id: "can-use-print-submission",
                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.canUsePrintSubmission = $event)),
                  type: "checkbox",
                  name: "can-use-print-submission",
                  class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.canUsePrintSubmission]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isSuperAdmin)
          ? (_openBlock(), _createBlock("div", _hoisted_81, [
              _hoisted_82,
              _createVNode("div", _hoisted_83, [
                _withDirectives(_createVNode("input", {
                  id: "can-save-voice-input-audio-in-school-ai-chat",
                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_ctx.canSaveVoiceInputAudioInSchoolAiChat = $event)),
                  type: "checkbox",
                  name: "can-save-voice-input-audio-in-school-ai-chat",
                  class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.canSaveVoiceInputAudioInSchoolAiChat]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isSuperAdmin)
          ? (_openBlock(), _createBlock("div", _hoisted_84, [
              _hoisted_85,
              _createVNode("div", _hoisted_86, [
                _withDirectives(_createVNode("input", {
                  id: "can-show-kawasemi-light",
                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_ctx.canShowKawasemiLight = $event)),
                  type: "checkbox",
                  name: "can-show-kawasemi-light",
                  class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.canShowKawasemiLight]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isServiceProvider)
          ? (_openBlock(), _createBlock("div", _hoisted_87, [
              _hoisted_88,
              _createVNode("div", _hoisted_89, [
                _withDirectives(_createVNode("input", {
                  id: "can-show-templates-and-guides-in-school-ai",
                  "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (_ctx.canShowTemplatesAndGuidesInSchoolAi = $event)),
                  type: "checkbox",
                  name: "can-show-templates-and-guides-in-school-ai",
                  class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.canShowTemplatesAndGuidesInSchoolAi]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isSuperAdmin)
          ? (_openBlock(), _createBlock("div", _hoisted_90, [
              _hoisted_91,
              _createVNode("div", _hoisted_92, [
                _withDirectives(_createVNode("input", {
                  id: "can-publish-app-to-store",
                  "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (_ctx.canPublishAppToStore = $event)),
                  type: "checkbox",
                  name: "can-publish-app-to-store",
                  class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.canPublishAppToStore]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isSuperAdmin)
          ? (_openBlock(), _createBlock("div", _hoisted_93, [
              _hoisted_94,
              _createVNode("div", _hoisted_95, [
                _withDirectives(_createVNode("input", {
                  id: "context-compression-canary-enabled",
                  "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (_ctx.contextCompressionCanaryEnabled = $event)),
                  type: "checkbox",
                  name: "context-compression-canary-enabled",
                  class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.contextCompressionCanaryEnabled]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isSuperAdmin)
          ? (_openBlock(), _createBlock("div", _hoisted_96, [
              _createVNode(_component_m_text_field, {
                label: "先生アカウントの最大数",
                name: "maxTutorCount",
                type: "number",
                placeholder: "未設定の場合は無制限",
                min: "0",
                step: "1",
                value: _ctx.maxTutorCount !== null ? _ctx.maxTutorCount : '',
                onInput: _ctx.handleMaxTutorCountInput,
                onBlur: _ctx.validateMaxTutorCount
              }, null, 8, ["value", "onInput", "onBlur"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isSuperAdmin)
          ? (_openBlock(), _createBlock("div", _hoisted_97, [
              _createVNode(_component_m_text_field, {
                label: "生徒アカウントの最大数",
                name: "maxStudentCount",
                type: "number",
                placeholder: "未設定の場合は無制限",
                min: "0",
                step: "1",
                value: _ctx.maxStudentCount !== null ? _ctx.maxStudentCount : '',
                onInput: _ctx.handleMaxStudentCountInput,
                onBlur: _ctx.validateMaxStudentCount
              }, null, 8, ["value", "onInput", "onBlur"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isSuperAdmin)
          ? (_openBlock(), _createBlock("div", _hoisted_98, [
              _hoisted_99,
              _createVNode("div", _hoisted_100, [
                _createVNode("div", null, [
                  _createVNode("button", {
                    type: "button",
                    class: "w-full px-4 py-4 flex items-center justify-between text-left hover:bg-primary-50 transition-colors",
                    onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.usageLimitStudentOpen = !_ctx.usageLimitStudentOpen))
                  }, [
                    _hoisted_101,
                    _createVNode("div", _hoisted_102, [
                      (_ctx.studentChatMessageUsageLimitConfig.enabled)
                        ? (_openBlock(), _createBlock("span", _hoisted_103, "有効"))
                        : (_openBlock(), _createBlock("span", _hoisted_104, "無効")),
                      (_openBlock(), _createBlock("svg", {
                        class: ["w-5 h-5 text-gray-400 transition-transform duration-200", { 'rotate-180': _ctx.usageLimitStudentOpen }],
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor"
                      }, [
                        _hoisted_105
                      ], 2))
                    ])
                  ]),
                  _withDirectives(_createVNode("div", _hoisted_106, [
                    _createVNode("div", _hoisted_107, [
                      _createVNode("label", _hoisted_108, [
                        _withDirectives(_createVNode("input", {
                          id: "school-student-chat-message-usage-limit-enabled",
                          "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => (_ctx.studentChatMessageUsageLimitConfig.enabled = $event)),
                          type: "checkbox",
                          class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.studentChatMessageUsageLimitConfig.enabled]
                        ]),
                        _hoisted_109
                      ])
                    ]),
                    _createVNode("div", _hoisted_110, [
                      _createVNode(_component_m_select_box, {
                        label: "利用制限の期間",
                        name: "school-student-chat-message-usage-limit-period",
                        placeholder: "利用制限の期間を選択",
                        options: _ctx.usageLimitPeriods,
                        value: _ctx.studentChatMessageUsageLimitConfig.period,
                        "value-key": "value",
                        "text-key": "label",
                        disabled: !_ctx.studentChatMessageUsageLimitConfig.enabled,
                        onChange: _cache[37] || (_cache[37] = ($event: any) => (_ctx.studentChatMessageUsageLimitConfig.period = $event))
                      }, null, 8, ["options", "value", "disabled"])
                    ]),
                    _createVNode("div", _hoisted_111, [
                      _createVNode(_component_m_text_field, {
                        label: "送信回数上限",
                        name: "school-student-chat-message-usage-limit",
                        type: "number",
                        placeholder: "1以上の半角数字",
                        min: "1",
                        step: "1",
                        value: 
                    _ctx.studentChatMessageUsageLimitConfig.limit !== null
                      ? _ctx.studentChatMessageUsageLimitConfig.limit
                      : ''
                  ,
                        disabled: !_ctx.studentChatMessageUsageLimitConfig.enabled,
                        invalid: !_ctx.validStudentChatMessageUsageLimit,
                        "invalid-message": "有効時は1以上の整数を入力してください",
                        onInput: _ctx.handleStudentChatMessageLimitInput
                      }, null, 8, ["value", "disabled", "invalid", "onInput"])
                    ]),
                    _createVNode("div", _hoisted_112, [
                      _createVNode("label", _hoisted_113, [
                        _withDirectives(_createVNode("input", {
                          id: "school-student-allow-individual-chat-message-settings",
                          "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => (_ctx.allowStudentIndividualChatMessageSettings = $event)),
                          type: "checkbox",
                          class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.allowStudentIndividualChatMessageSettings]
                        ]),
                        _hoisted_114
                      ]),
                      _hoisted_115
                    ]),
                    _createVNode("div", _hoisted_116, [
                      _createVNode(_component_m_text_field, {
                        label: "警告表示の残数",
                        name: "school-student-chat-message-warning-threshold",
                        type: "number",
                        placeholder: "未設定の場合は上限の20%",
                        min: "0",
                        step: "1",
                        value: 
                    _ctx.studentChatMessageUsageLimitConfig.warningThreshold !==
                      null &&
                    _ctx.studentChatMessageUsageLimitConfig.warningThreshold !==
                      undefined
                      ? _ctx.studentChatMessageUsageLimitConfig.warningThreshold
                      : ''
                  ,
                        disabled: !_ctx.studentChatMessageUsageLimitConfig.enabled,
                        invalid: !_ctx.validStudentChatMessageWarningThreshold,
                        "invalid-message": "有効時は0以上かつ送信回数上限以下の整数を入力してください",
                        onInput: _ctx.handleStudentChatMessageWarningThresholdInput
                      }, null, 8, ["value", "disabled", "invalid", "onInput"]),
                      _hoisted_117
                    ]),
                    _createVNode("div", _hoisted_118, [
                      _createVNode("label", _hoisted_119, [
                        _withDirectives(_createVNode("input", {
                          id: "school-student-chat-message-count-system-prompt",
                          "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => (
                      _ctx.studentChatMessageUsageLimitConfig.countSystemPrompt
                     = $event)),
                          type: "checkbox",
                          class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded",
                          disabled: !_ctx.studentChatMessageUsageLimitConfig.enabled
                        }, null, 8, ["disabled"]), [
                          [_vModelCheckbox, 
                      _ctx.studentChatMessageUsageLimitConfig.countSystemPrompt
                    ]
                        ]),
                        _hoisted_120
                      ])
                    ]),
                    _createVNode("div", _hoisted_121, [
                      _createVNode(_component_m_text_field, {
                        label: "有効期限",
                        name: "school-student-chat-message-usage-limit-expires-at",
                        type: "date",
                        placeholder: "未設定の場合は無期限",
                        value: _ctx.studentChatMessageLimitExpiresAtDate,
                        disabled: !_ctx.studentChatMessageUsageLimitConfig.enabled,
                        onInput: _cache[40] || (_cache[40] = ($event: any) => (_ctx.studentChatMessageLimitExpiresAtDate = $event))
                      }, null, 8, ["value", "disabled"]),
                      _hoisted_122,
                      _hoisted_123
                    ])
                  ], 512), [
                    [_vShow, _ctx.usageLimitStudentOpen]
                  ])
                ]),
                _createVNode("div", null, [
                  _createVNode("button", {
                    type: "button",
                    class: "w-full px-4 py-4 flex items-center justify-between text-left hover:bg-primary-50 transition-colors",
                    onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.usageLimitTutorOpen = !_ctx.usageLimitTutorOpen))
                  }, [
                    _hoisted_124,
                    _createVNode("div", _hoisted_125, [
                      (_ctx.tutorChatMessageUsageLimitConfig.enabled)
                        ? (_openBlock(), _createBlock("span", _hoisted_126, "有効"))
                        : (_openBlock(), _createBlock("span", _hoisted_127, "無効")),
                      (_openBlock(), _createBlock("svg", {
                        class: ["w-5 h-5 text-gray-400 transition-transform duration-200", { 'rotate-180': _ctx.usageLimitTutorOpen }],
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor"
                      }, [
                        _hoisted_128
                      ], 2))
                    ])
                  ]),
                  _withDirectives(_createVNode("div", _hoisted_129, [
                    _createVNode("div", _hoisted_130, [
                      _createVNode("label", _hoisted_131, [
                        _withDirectives(_createVNode("input", {
                          id: "school-tutor-chat-message-usage-limit-enabled",
                          "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => (_ctx.tutorChatMessageUsageLimitConfig.enabled = $event)),
                          type: "checkbox",
                          class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.tutorChatMessageUsageLimitConfig.enabled]
                        ]),
                        _hoisted_132
                      ])
                    ]),
                    _createVNode("div", _hoisted_133, [
                      _createVNode(_component_m_select_box, {
                        label: "利用制限の期間",
                        name: "school-tutor-chat-message-usage-limit-period",
                        placeholder: "利用制限の期間を選択",
                        options: _ctx.usageLimitPeriods,
                        value: _ctx.tutorChatMessageUsageLimitConfig.period,
                        "value-key": "value",
                        "text-key": "label",
                        disabled: !_ctx.tutorChatMessageUsageLimitConfig.enabled,
                        onChange: _cache[43] || (_cache[43] = ($event: any) => (_ctx.tutorChatMessageUsageLimitConfig.period = $event))
                      }, null, 8, ["options", "value", "disabled"])
                    ]),
                    _createVNode("div", _hoisted_134, [
                      _createVNode(_component_m_text_field, {
                        label: "送信回数上限",
                        name: "school-tutor-chat-message-usage-limit",
                        type: "number",
                        placeholder: "1以上の半角数字",
                        min: "1",
                        step: "1",
                        value: 
                    _ctx.tutorChatMessageUsageLimitConfig.limit !== null
                      ? _ctx.tutorChatMessageUsageLimitConfig.limit
                      : ''
                  ,
                        disabled: !_ctx.tutorChatMessageUsageLimitConfig.enabled,
                        invalid: !_ctx.validTutorChatMessageUsageLimit,
                        "invalid-message": "有効時は1以上の整数を入力してください",
                        onInput: _ctx.handleTutorChatMessageLimitInput
                      }, null, 8, ["value", "disabled", "invalid", "onInput"])
                    ]),
                    _createVNode("div", _hoisted_135, [
                      _createVNode(_component_m_text_field, {
                        label: "警告表示の残数",
                        name: "school-tutor-chat-message-warning-threshold",
                        type: "number",
                        placeholder: "未設定の場合は上限の20%",
                        min: "0",
                        step: "1",
                        value: 
                    _ctx.tutorChatMessageUsageLimitConfig.warningThreshold !==
                      null &&
                    _ctx.tutorChatMessageUsageLimitConfig.warningThreshold !==
                      undefined
                      ? _ctx.tutorChatMessageUsageLimitConfig.warningThreshold
                      : ''
                  ,
                        disabled: !_ctx.tutorChatMessageUsageLimitConfig.enabled,
                        invalid: !_ctx.validTutorChatMessageWarningThreshold,
                        "invalid-message": "有効時は0以上かつ送信回数上限以下の整数を入力してください",
                        onInput: _ctx.handleTutorChatMessageWarningThresholdInput
                      }, null, 8, ["value", "disabled", "invalid", "onInput"]),
                      _hoisted_136
                    ]),
                    _createVNode("div", _hoisted_137, [
                      _createVNode("label", _hoisted_138, [
                        _withDirectives(_createVNode("input", {
                          id: "school-tutor-chat-message-count-system-prompt",
                          "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => (_ctx.tutorChatMessageUsageLimitConfig.countSystemPrompt = $event)),
                          type: "checkbox",
                          class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded",
                          disabled: !_ctx.tutorChatMessageUsageLimitConfig.enabled
                        }, null, 8, ["disabled"]), [
                          [_vModelCheckbox, _ctx.tutorChatMessageUsageLimitConfig.countSystemPrompt]
                        ]),
                        _hoisted_139
                      ])
                    ]),
                    _createVNode("div", _hoisted_140, [
                      _createVNode(_component_m_text_field, {
                        label: "有効期限",
                        name: "school-tutor-chat-message-usage-limit-expires-at",
                        type: "date",
                        placeholder: "未設定の場合は無期限",
                        value: _ctx.tutorChatMessageLimitExpiresAtDate,
                        disabled: !_ctx.tutorChatMessageUsageLimitConfig.enabled,
                        onInput: _cache[45] || (_cache[45] = ($event: any) => (_ctx.tutorChatMessageLimitExpiresAtDate = $event))
                      }, null, 8, ["value", "disabled"]),
                      _hoisted_141,
                      _hoisted_142
                    ])
                  ], 512), [
                    [_vShow, _ctx.usageLimitTutorOpen]
                  ])
                ]),
                _createVNode("div", null, [
                  _createVNode("button", {
                    type: "button",
                    class: "w-full px-4 py-4 flex items-center justify-between text-left hover:bg-primary-50 transition-colors",
                    onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.usageLimitSchoolLevelOpen = !_ctx.usageLimitSchoolLevelOpen))
                  }, [
                    _hoisted_143,
                    _createVNode("div", _hoisted_144, [
                      (_ctx.schoolLevelChatMessageUsageLimitConfig.enabled)
                        ? (_openBlock(), _createBlock("span", _hoisted_145, "有効"))
                        : (_openBlock(), _createBlock("span", _hoisted_146, "無効")),
                      (_openBlock(), _createBlock("svg", {
                        class: ["w-5 h-5 text-gray-400 transition-transform duration-200", { 'rotate-180': _ctx.usageLimitSchoolLevelOpen }],
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor"
                      }, [
                        _hoisted_147
                      ], 2))
                    ])
                  ]),
                  _withDirectives(_createVNode("div", _hoisted_148, [
                    _createVNode("div", _hoisted_149, [
                      _createVNode("label", _hoisted_150, [
                        _withDirectives(_createVNode("input", {
                          id: "school-level-chat-message-usage-limit-enabled",
                          "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => (_ctx.schoolLevelChatMessageUsageLimitConfig.enabled = $event)),
                          type: "checkbox",
                          class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.schoolLevelChatMessageUsageLimitConfig.enabled]
                        ]),
                        _hoisted_151
                      ])
                    ]),
                    _createVNode("div", _hoisted_152, [
                      _createVNode(_component_m_select_box, {
                        label: "利用制限の期間",
                        name: "school-level-chat-message-usage-limit-period",
                        placeholder: "利用制限の期間を選択",
                        options: _ctx.usageLimitPeriods,
                        value: _ctx.schoolLevelChatMessageUsageLimitConfig.period,
                        "value-key": "value",
                        "text-key": "label",
                        disabled: !_ctx.schoolLevelChatMessageUsageLimitConfig.enabled,
                        onChange: _cache[48] || (_cache[48] = ($event: any) => (
                    _ctx.schoolLevelChatMessageUsageLimitConfig.period = $event
                  ))
                      }, null, 8, ["options", "value", "disabled"])
                    ]),
                    _createVNode("div", _hoisted_153, [
                      _createVNode(_component_m_text_field, {
                        label: "送信回数上限",
                        name: "school-level-chat-message-usage-limit",
                        type: "number",
                        placeholder: "1以上の半角数字",
                        min: "1",
                        step: "1",
                        value: 
                    _ctx.schoolLevelChatMessageUsageLimitConfig.limit !== null
                      ? _ctx.schoolLevelChatMessageUsageLimitConfig.limit
                      : ''
                  ,
                        disabled: !_ctx.schoolLevelChatMessageUsageLimitConfig.enabled,
                        invalid: !_ctx.validSchoolLevelChatMessageUsageLimit,
                        "invalid-message": "有効時は1以上の整数を入力してください",
                        onInput: _ctx.handleSchoolLevelChatMessageLimitInput
                      }, null, 8, ["value", "disabled", "invalid", "onInput"])
                    ]),
                    _createVNode("div", _hoisted_154, [
                      _createVNode(_component_m_text_field, {
                        label: "警告表示の残数",
                        name: "school-level-chat-message-warning-threshold",
                        type: "number",
                        placeholder: "未設定の場合は上限の20%",
                        min: "0",
                        step: "1",
                        value: 
                    _ctx.schoolLevelChatMessageUsageLimitConfig.warningThreshold !==
                      null &&
                    _ctx.schoolLevelChatMessageUsageLimitConfig.warningThreshold !==
                      undefined
                      ? _ctx.schoolLevelChatMessageUsageLimitConfig.warningThreshold
                      : ''
                  ,
                        disabled: !_ctx.schoolLevelChatMessageUsageLimitConfig.enabled,
                        invalid: !_ctx.validSchoolLevelChatMessageWarningThreshold,
                        "invalid-message": "有効時は0以上かつ送信回数上限以下の整数を入力してください",
                        onInput: _ctx.handleSchoolLevelChatMessageWarningThresholdInput
                      }, null, 8, ["value", "disabled", "invalid", "onInput"]),
                      _hoisted_155
                    ]),
                    _createVNode("div", _hoisted_156, [
                      _createVNode("label", _hoisted_157, [
                        _withDirectives(_createVNode("input", {
                          id: "school-level-chat-message-count-system-prompt",
                          "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => (
                      _ctx.schoolLevelChatMessageUsageLimitConfig.countSystemPrompt
                     = $event)),
                          type: "checkbox",
                          class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded",
                          disabled: !_ctx.schoolLevelChatMessageUsageLimitConfig.enabled
                        }, null, 8, ["disabled"]), [
                          [_vModelCheckbox, 
                      _ctx.schoolLevelChatMessageUsageLimitConfig.countSystemPrompt
                    ]
                        ]),
                        _hoisted_158
                      ])
                    ]),
                    _createVNode("div", _hoisted_159, [
                      _createVNode(_component_m_text_field, {
                        label: "有効期限",
                        name: "school-level-chat-message-usage-limit-expires-at",
                        type: "date",
                        placeholder: "未設定の場合は無期限",
                        value: _ctx.schoolLevelChatMessageLimitExpiresAtDate,
                        disabled: !_ctx.schoolLevelChatMessageUsageLimitConfig.enabled,
                        onInput: _cache[50] || (_cache[50] = ($event: any) => (_ctx.schoolLevelChatMessageLimitExpiresAtDate = $event))
                      }, null, 8, ["value", "disabled"]),
                      _hoisted_160,
                      _hoisted_161
                    ])
                  ], 512), [
                    [_vShow, _ctx.usageLimitSchoolLevelOpen]
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isSuperAdmin)
          ? (_openBlock(), _createBlock("div", _hoisted_162, [
              _hoisted_163,
              _createVNode("div", _hoisted_164, [
                _createVNode("div", _hoisted_165, [
                  _createVNode("div", null, [
                    _createVNode("p", _hoisted_166, _toDisplayString(_ctx.llmUsageLimitCurrentText), 1),
                    _createVNode("p", _hoisted_167, _toDisplayString(_ctx.llmUsageLimitCurrentSourceText), 1),
                    (_ctx.ownLlmUsageLimit)
                      ? (_openBlock(), _createBlock("p", _hoisted_168, " 既定値：" + _toDisplayString(_ctx.llmUsageLimitDefaultText), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_m_button, {
                    color: "primary-500",
                    "hover-color": "primary-600",
                    class: "flex-shrink-0",
                    disabled: _ctx.limits === null,
                    onClick: _cache[51] || (_cache[51] = ($event: any) => (_ctx.showLlmUsageLimitModal = true))
                  }, {
                    default: _withId(() => [
                      _hoisted_169
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                (_ctx.ownLlmUsageLimit)
                  ? (_openBlock(), _createBlock("div", _hoisted_170, [
                      _createVNode("span", null, "最終更新：" + _toDisplayString(_ctx.formatEpoch(_ctx.ownLlmUsageLimit.changedAt)), 1),
                      _createVNode("span", null, "更新者：" + _toDisplayString(_ctx.ownLlmUsageLimit.changedByName), 1),
                      _createVNode("span", null, "理由：" + _toDisplayString(_ctx.ownLlmUsageLimit.reason), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.scheduledLlmUsageLimits, (row) => {
                  return (_openBlock(), _createBlock("div", {
                    key: row.effectiveFrom,
                    class: "mt-3 p-3 bg-white rounded flex items-center justify-between gap-3"
                  }, [
                    _createVNode("div", _hoisted_171, [
                      _createVNode("span", _hoisted_172, " 予定：" + _toDisplayString(_ctx.llmUsageLimitRowText(row)), 1),
                      _createVNode("span", _hoisted_173, " 適用開始：" + _toDisplayString(_ctx.formatEpoch(row.effectiveFrom)), 1),
                      _createVNode("span", _hoisted_174, " 登録：" + _toDisplayString(_ctx.formatEpoch(row.changedAt)), 1),
                      _createVNode("span", _hoisted_175, " 登録者：" + _toDisplayString(row.changedByName), 1),
                      _createVNode("span", _hoisted_176, "理由：" + _toDisplayString(row.reason), 1)
                    ]),
                    _createVNode(_component_m_button, {
                      color: "gray-400",
                      "hover-color": "gray-500",
                      outline: "",
                      class: "flex-shrink-0",
                      onClick: ($event: any) => (_ctx.cancelLlmUsageLimit(row))
                    }, {
                      default: _withId(() => [
                        _hoisted_177
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isSuperAdmin)
          ? (_openBlock(), _createBlock("div", _hoisted_178, [
              _hoisted_179,
              _createVNode("div", _hoisted_180, [
                _withDirectives(_createVNode("input", {
                  id: "notification",
                  "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => (_ctx.allowCreateRoom = $event)),
                  type: "checkbox",
                  name: "notification",
                  class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.allowCreateRoom]
                ]),
                _hoisted_181,
                _withDirectives(_createVNode("div", _hoisted_182, [
                  _hoisted_183,
                  _withDirectives(_createVNode("input", {
                    "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => (_ctx.zoomUserId = $event)),
                    disabled: !_ctx.allowCreateRoom,
                    class: "pl-1 w-96",
                    placeholder: "紐づけたいzoomのメール/ID名を入力してください"
                  }, null, 8, ["disabled"]), [
                    [_vModelText, _ctx.zoomUserId]
                  ])
                ], 512), [
                  [_vShow, _ctx.allowCreateRoom]
                ])
              ]),
              _createVNode("div", _hoisted_184, [
                _withDirectives(_createVNode("input", {
                  id: "lineOfficialAccount",
                  "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => (_ctx.allowUseOfCustomOfficialLine = $event)),
                  type: "checkbox",
                  name: "lineOfficialAccount",
                  class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.allowUseOfCustomOfficialLine]
                ]),
                _hoisted_185,
                _createVNode("div", null, [
                  _withDirectives(_createVNode("div", _hoisted_186, [
                    _hoisted_187,
                    _withDirectives(_createVNode("input", {
                      "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => (_ctx.lineOfficialAccountChannelAccessToken = $event)),
                      disabled: !_ctx.allowUseOfCustomOfficialLine,
                      class: "pl-1 w-96",
                      placeholder: "チャネルアクセストークンを入力してください"
                    }, null, 8, ["disabled"]), [
                      [_vModelText, _ctx.lineOfficialAccountChannelAccessToken]
                    ])
                  ], 512), [
                    [_vShow, _ctx.allowUseOfCustomOfficialLine]
                  ]),
                  _withDirectives(_createVNode("div", _hoisted_188, [
                    _hoisted_189,
                    _withDirectives(_createVNode("input", {
                      "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => (_ctx.lineOfficialAccountChannelSecret = $event)),
                      disabled: !_ctx.allowUseOfCustomOfficialLine,
                      class: "pl-1 w-96",
                      placeholder: "チャネルシークレットを入力してください"
                    }, null, 8, ["disabled"]), [
                      [_vModelText, _ctx.lineOfficialAccountChannelSecret]
                    ])
                  ], 512), [
                    [_vShow, _ctx.allowUseOfCustomOfficialLine]
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_190, [
          _createVNode(_component_m_text_field, {
            label: "利用開始日",
            name: "day",
            type: "date",
            placeholder: "2021/08/01",
            value: _ctx.activateDay,
            onInput: _cache[57] || (_cache[57] = ($event: any) => (_ctx.activateDay = $event))
          }, null, 8, ["value"])
        ]),
        (_ctx.tutors.length)
          ? (_openBlock(), _createBlock("div", _hoisted_191, [
              _hoisted_192,
              _createVNode("div", _hoisted_193, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tutors, (tutor, index) => {
                  return (_openBlock(), _createBlock("div", {
                    key: tutor.email,
                    class: ["flex items-center justify-between w-full py-2", { 'border-b-2 border-white': index < _ctx.tutors.length - 1 }]
                  }, [
                    _createVNode("span", _hoisted_194, _toDisplayString(tutor.email), 1),
                    _createVNode(_component_m_button, {
                      color: "primary-500",
                      "hover-color": "primary-600",
                      class: "ml-4",
                      onClick: ($event: any) => (_ctx.handleChangeEmail(tutor))
                    }, {
                      default: _withId(() => [
                        _hoisted_195
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ], 2))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_196, [
          _hoisted_197,
          _createVNode("div", _hoisted_198, [
            _createVNode("div", _hoisted_199, _toDisplayString(_ctx.schoolConfig.data.recessTime ? "休会" : "利用中"), 1)
          ])
        ])
      ]),
      footer: _withId(() => [
        (_ctx.inRecess)
          ? (_openBlock(), _createBlock(_component_m_button, {
              key: 0,
              color: "red-400",
              "hover-color": "red-500",
              outline: "",
              class: "mr-4",
              onClick: _ctx.changeRecess
            }, {
              default: _withId(() => [
                _hoisted_200
              ]),
              _: 1
            }, 8, ["onClick"]))
          : (_openBlock(), _createBlock(_component_m_button, {
              key: 1,
              color: "red-400",
              "hover-color": "red-500",
              outline: "",
              class: "mr-4",
              onClick: _ctx.changeRecess
            }, {
              default: _withId(() => [
                _hoisted_201
              ]),
              _: 1
            }, 8, ["onClick"])),
        _createVNode(_component_m_button, {
          color: "primary-500",
          "hover-color": "primary-600",
          disabled: !_ctx.validData,
          onClick: _ctx.update
        }, {
          default: _withId(() => [
            _hoisted_202
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ]),
      _: 1
    }, 8, ["onClose"])
  ], 64))
})